class B2BRegistrationForm extends HTMLElement {
  connectedCallback() {
    this.apiUrl = this.dataset.apiUrl?.replace(/\/$/, '') || ''
    this.customerId = this.dataset.customerId || ''
    this.customerEmail = this.dataset.customerEmail || ''
    this.loggedIn = this.dataset.loggedIn === 'true'
    this.emailInput = this.querySelector('#b2b-email')
    this.form = this.querySelector('#b2b-reg-form')
    this.icoInput = this.querySelector('#b2b-ico')
    this.aresStatus = this.querySelector('.b2b-form__ares-status')
    this.autofillGroup = this.querySelector('.b2b-form__autofill-group')
    this.result = this.querySelector('.b2b-form__result')
    this.submitBtn = this.querySelector('[type="submit"]')

    this.icoInput?.addEventListener('blur', () => this.onIcoBlur())
    this.icoInput?.addEventListener('input', () => this.onIcoInput())
    this.form?.addEventListener('submit', (e) => this.onSubmit(e))
  }

  onIcoInput() {
    this.clearAresStatus()
    this.autofillGroup?.classList.remove('is-filled')
    this.clearAutofill()
  }

  async onIcoBlur() {
    const ico = this.icoInput.value.trim()
    if (!ico) return

    if (!this.validateIcoFormat(ico)) {
      this.setAresStatus('error', 'Neplatné IČO – musí mít 8 číslic')
      return
    }

    this.setAresStatus('loading', 'Načítám z ARES…')

    try {
      const res = await fetch(`${this.apiUrl}/api/ares?ico=${encodeURIComponent(ico)}`)
      const data = await res.json()

      if (!res.ok) {
        this.setAresStatus('error', data.error || 'IČO nenalezeno v ARES')
        return
      }

      this.fillFromAres(data)
      this.setAresStatus('success', `Nalezeno: ${data.company_name}`)
      this.autofillGroup?.classList.add('is-filled')
    } catch {
      this.setAresStatus('error', 'Chyba při komunikaci s ARES, zkuste to prosím znovu')
    }
  }

  fillFromAres(data) {
    this.setField('b2b-company-name', data.company_name || '')
    this.setField('b2b-dic', data.dic || '')
    this.setCheckbox('b2b-vat-payer', data.is_vat_payer || false)
    this.setField('b2b-street', data.address?.street || '')
    this.setField('b2b-city', data.address?.city || '')
    this.setField('b2b-zip', data.address?.zip || '')
  }

  clearAutofill() {
    ['b2b-company-name', 'b2b-dic', 'b2b-street', 'b2b-city', 'b2b-zip'].forEach(id => this.setField(id, ''))
    this.setCheckbox('b2b-vat-payer', false)
  }

  setField(id, value) {
    const el = this.querySelector(`#${id}`)
    if (el) el.value = value
  }

  setCheckbox(id, checked) {
    const el = this.querySelector(`#${id}`)
    if (el) el.checked = checked
  }

  setAresStatus(type, text) {
    if (!this.aresStatus) return
    this.aresStatus.className = `b2b-form__ares-status b2b-form__ares-status--${type}`
    if (type === 'loading') {
      this.aresStatus.innerHTML = `<span class="b2b-form__ares-spinner"></span>${text}`
    } else {
      this.aresStatus.textContent = text
    }
  }

  clearAresStatus() {
    if (!this.aresStatus) return
    this.aresStatus.className = 'b2b-form__ares-status'
    this.aresStatus.textContent = ''
  }

  validateIcoFormat(ico) {
    if (!/^\d{8}$/.test(ico)) return false
    const d = ico.split('').map(Number)
    const weights = [8, 7, 6, 5, 4, 3, 2]
    const sum = weights.reduce((acc, w, i) => acc + w * d[i], 0)
    const rem = sum % 11
    let check
    if (rem === 0) check = 1
    else if (rem === 1) check = 0
    else check = 11 - rem
    return d[7] === check
  }

  async onSubmit(e) {
    e.preventDefault()
    if (!this.form.checkValidity()) {
      this.form.reportValidity()
      return
    }

    this.setSubmitting(true)
    this.hideResult()

    const payload = {
      // customer_id posíláme jen u přihlášeného; nepřihlášený se identifikuje emailem.
      ...(this.customerId ? { customer_id: this.customerId } : {}),
      email: this.getEmail(),
      ico: this.getField('b2b-ico'),
      company_name: this.getField('b2b-company-name'),
      dic: this.getField('b2b-dic') || undefined,
      is_vat_payer: this.getCheckbox('b2b-vat-payer'),
      address_street: this.getField('b2b-street'),
      address_city: this.getField('b2b-city'),
      address_zip: this.getField('b2b-zip'),
      first_name: this.getField('b2b-first-name'),
      last_name: this.getField('b2b-last-name'),
      phone: this.getField('b2b-phone'),
      expected_volume: this.getField('b2b-volume'),
      note: this.getField('b2b-note') || '',
      consent: true,
    }

    try {
      const res = await fetch(`${this.apiUrl}/api/b2b/submit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
      const data = await res.json()

      if (res.ok) {
        this.form.style.display = 'none'
        this.showResult('success', 'Vaše žádost byla přijata. Odpovíme vám do 2 pracovních dnů.')
      } else {
        this.showResult('error', data.error || 'Došlo k chybě, zkuste to prosím znovu.')
        this.setSubmitting(false)
      }
    } catch {
      this.showResult('error', 'Nepodařilo se odeslat žádost. Zkontrolujte připojení a zkuste to znovu.')
      this.setSubmitting(false)
    }
  }

  getEmail() {
    // Pole existuje vždy kromě edge-case, kdy je přihlášený uživatel bez emailu —
    // pak se pole skryje a identitu vezmeme z data-customer-email.
    return this.emailInput?.value?.trim() || this.customerEmail
  }

  getField(id) {
    return this.querySelector(`#${id}`)?.value?.trim() || ''
  }

  getCheckbox(id) {
    return this.querySelector(`#${id}`)?.checked || false
  }

  setSubmitting(loading) {
    if (!this.submitBtn) return
    this.submitBtn.disabled = loading
    this.submitBtn.textContent = loading ? 'Odesílám…' : 'Odeslat žádost'
  }

  showResult(type, message) {
    if (!this.result) return
    this.result.className = `b2b-form__result b2b-form__result--${type} is-visible`
    this.result.textContent = message
  }

  hideResult() {
    if (!this.result) return
    this.result.className = 'b2b-form__result'
  }
}

customElements.define('b2b-registration-form', B2BRegistrationForm)
